import type { FormikProps } from 'formik';
import { map, noop } from 'lodash-es';
import { useMemo } from 'react';
import { useCollectionListAll } from '../../../api';
import { PropertySelector } from '../../Properties/PropertySelector';
import type { TemplateFormik } from './ManageTemplatePage';

export interface CollectionsPropertySelectorProps {
	formik: FormikProps<TemplateFormik>;
}

export function CollectionsTemplateSelector({
	formik,
}: CollectionsPropertySelectorProps) {
	const { data: collections } = useCollectionListAll();

	const collectionOptions = useMemo(
		() =>
			map(collections?.results, (collection) => ({
				label: collection.title || 'Untitled',
				value: collection.id,
				icon: collection.icon,
				navigateTo: `/collections/${collection.id}`,
				onClick: noop,
			})),
		[collections]
	);

	return (
		<PropertySelector
			selected={formik.values.collections}
			type="multi"
			value="collections"
			iconType="emoji"
			options={collectionOptions}
			isViewerUser={false}
			readOnly={false}
			placeholder={'Add to collection'}
			placeholderIconName="folder"
			onChange={(value) => void formik.setFieldValue('collections', value)}
		/>
	);
}
